export enum FunctionResultStatus {
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
}
